<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">

	<div *ngIf="showFieldCotraitant" class="row my-4">
		<div class="form-check form-switch ms-2"
		>
			<input
				class="form-check-input theme-main-border-color"
				type="checkbox"
				id="cotraitant"
				formControlName="cotraitant"
				[ngClass]="{
					'theme-main-color-check': cotraitant.value
				}"
				(ngModelChange)="checkRelatedBdcLine()"
			/>
			<label class="form-check-label text-dark" for="cotraitant"
				>Soutien pour le compte du cotraitant</label
			>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="!this.isIntervenant" class="col-12 col-lg">
			<label for="intervenant" class="form-label fw-bold"
				>Intervenant</label
			>
			<select
				required
				id="intervenant"
				class="form-select"
				name="intervenant"
				formControlName="intervenant"
				aria-label="Sélectionner un intervenant"
				[ngClass]="{
					'is-invalid': intervenant.invalid,
					'is-valid': intervenant.dirty && intervenant.valid
				}"
				>
				<option *ngFor="let intervenant of listIntervenant |  orderBy:'lastName' " value="{{ intervenant.id }}">
					{{ intervenant.lastName + ' ' + intervenant.firstName}}
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('dateEntretien')" class="col-12 col-lg">
			<label for="dateEntretien" class="form-label fw-bold"
				>Date d'entretien</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateEntretien"
				name="dateEntretien"
				formControlName="dateEntretien"
				(ngModelChange)="checkRelatedBdcLine()"
             	[maxDate]="maxDate"
				[minDate]="minDate"
				[ngClass]="{
					'is-invalid': dateEntretien.invalid,
					'is-valid': dateEntretien.dirty && dateEntretien.valid
				}"
			/>
		</div>
	</div>

	<!-- <div class="row my-4">
		<div *ngIf="form.contains('dateProchainEntretien')" class="col-12 col-lg">
			<label for="dateProchainEntretien" class="form-label fw-bold"
				>Date du prochain entretien</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateProchainEntretien"
				name="dateProchainEntretien"
				formControlName="dateProchainEntretien"
				[ngClass]="{
					'is-invalid': dateProchainEntretien.invalid,
					'is-valid': dateProchainEntretien.dirty && dateProchainEntretien.valid
				}"
			/>
		</div>
	</div> -->

	<!-- <div class="row my-4">
		<div class="col-12 col-lg">
			<label for="typeEntretien" class="form-label fw-bold"
				>Type d'entretien</label
			>
			<select
				id="typeEntretien"
				class="form-select"
				name="typeEntretien"
				formControlName="typeEntretien"
				aria-label="Sélectionner un type d'entretien"
				>
				<option *ngFor="let typeEntretien of listTypeEntretien" value="{{ typeEntretien.id }}">
					{{ typeEntretien.name}}
				</option>
			</select>
		</div>
	</div> -->

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="modaliteReunion" class="form-label fw-bold"
				>Modalité de réunion</label
			>
			<select
				id="modaliteReunion"
				class="form-select"
				name="modaliteReunion"
				formControlName="modaliteReunion"
				aria-label="Sélectionner une modalité de réunion"
				>
				<option *ngFor="let modaliteReunion of listModaliteReunion" value="{{ modaliteReunion.id }}">
					{{ modaliteReunion.name}}
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="tache" class="form-label fw-bold"
				>Type entretien</label
			>
			<select
				id="tache"
				class="form-select"
				name="tache"
				formControlName="tache"
				>
				<option *ngFor="let tache of listTache" value="{{ tache.id }}">
					{{ tache.name}}
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('chargeTravail')" class="col-12 col-lg">
			<label for="chargeTravail" class="form-label fw-bold"
				>Charge de travail</label
			>
			<!-- <ngx-slider
				id="chargeTravail"
				formControlName="chargeTravail"
				name="chargeTravail"
				style="width: 40%; margin-left: 10%"
				[options]="options">
			</ngx-slider> -->
			<input
				type="number"
				[max]="heuresRestantes"
				class="form-control"
				formControlName="chargeTravail"
				placeholder="En heures"
				step="0.25"
				required
				(change)="checkRelatedBdcLine()"
				[ngClass]="{
					'is-invalid': chargeTravail.invalid,
					'is-valid': chargeTravail.dirty && chargeTravail.valid
				}"
			/>	
			<div *ngIf="form.get('chargeTravail')?.hasError('notQuarter')" class="text-danger">
				Format en quart d'unité. Exemple: 0,25 ; 0,5 ; 1
			  </div>
			
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('description')" class="col-12 col-lg">
			<label for="description" class="form-label fw-bold"
				>Description</label
			>
			<textarea
				autocomplete="off"
				type="text"
				class="form-control"
				id="description"
				name="description"
				formControlName="description"
				[ngClass]="{
					'is-invalid': description.invalid,
					'is-valid': description.dirty && description.valid
							}"
			></textarea>
		</div>
	</div>

	<div *ngIf="listRelatedReferenceBdc?.length == 0" class="alert alert-danger alert-dismissible fade show my-2"
			profile="alert"
				>
			Aucun bon de commande disponible.
	</div>
	<div  *ngIf="listRelatedReferenceBdc?.length > 0" class="row my-4">
		<div class="col-12 col-lg">
			<label for="bonCommandeReference" class="form-label fw-bold"
				>Bon de commande associé</label
			>
			<select
				required
				id="bonCommandeReference"
				class="form-select"
				name="bonCommandeReference"
				formControlName="bonCommandeReference"
				>
				<option *ngFor="let bonCommandeReference of listRelatedReferenceBdc" value="{{ bonCommandeReference.id }}">
					{{ bonCommandeReference.bonCommande.commande + ' ' + bonCommandeReference.bonCommande.marche + ' ' +  bonCommandeReference.bonCommande.lot}}
				</option>
			</select>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value || listRelatedReferenceBdc?.length === 0"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
